import React from 'react';

import styled, { useTheme } from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { desktop } from '../../styles';
import { BasicButton } from '../../styles/button';
import { Component as Price } from '../ExtendedPrice';

import { Section as BaseSection, Content, Subtitle, Title } from './shared';

const Section = styled(BaseSection).attrs({ desktopOnly: true })`
  padding-top: 10%;
`;
const SubtitleSection = styled.div`
  max-width: 100%;
  width: 100%;

  ${desktop`
    max-width: 60%;
    margin: 0 auto;
  `}
`;
interface GuestSectionProps {
  guestPrice: number;
  onContinueAsGuest: () => void;
}

export const GuestSection = ({
  guestPrice,
  onContinueAsGuest,
}: GuestSectionProps) => {
  const theme = useTheme();

  return (
    <Section>
      <Content>
        <Title color={theme.colors.gunmetal}>
          <FormattedMessage
            defaultMessage="CONTINUE AS A GUEST"
            id="global_checkout.membership_modal_guest_title"
            values={{
              price: <Price amount={guestPrice} />,
            }}
          />
        </Title>
        <SubtitleSection>
          <Subtitle color={theme.colors.gunmetal}>
            <FormattedMessage
              defaultMessage="You pay full price and lose all potential member benefits if continue as a Non-Member"
              id="global_checkout.membership_modal_guest_subtitle"
              values={{
                price: <Price amount={guestPrice} />,
              }}
            />
          </Subtitle>
        </SubtitleSection>
        {/*  @ts-ignore */}
        <BasicButton
          fullWidth
          variant="primaryDark"
          onClick={onContinueAsGuest}
        >
          <FormattedMessage
            defaultMessage="Go to Checkout"
            id="global_checkout.go_to_checkout_cta"
          />
        </BasicButton>
      </Content>
    </Section>
  );
};
